import { Icon } from '@iconify/react';

interface BlockedUserModalProps {
  isOpen: boolean;
  onContactSupport: () => void;
}

export const BlockedUserModal: React.FC<BlockedUserModalProps> = ({ isOpen, onContactSupport }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/70 p-4 backdrop-blur-md">
      <div className="relative w-full max-w-md rounded-[24px] border border-rose-500/20 bg-[linear-gradient(160deg,rgba(30,10,10,0.98),rgba(10,8,8,0.96))] p-6 shadow-[0_34px_100px_rgba(0,0,0,0.5)]">
        {/* Glow */}
        <div className="pointer-events-none absolute inset-0 rounded-[24px] bg-[radial-gradient(circle_at_top_left,rgba(239,68,68,0.12),transparent_26%)]" />

        <div className="relative flex flex-col items-center text-center">
          <span className="flex h-16 w-16 items-center justify-center rounded-full border border-rose-500/20 bg-rose-500/10 text-rose-300">
            <Icon icon="bx:lock-alt" className="h-8 w-8" />
          </span>

          <h2 className="mt-4 text-xl font-black tracking-tight text-white">
            Account blocked
          </h2>

          <p className="mt-3 text-[14px] leading-6 text-rose-200/80">
            Sorry, seems like your user account has been blocked.
          </p>

          <p className="mt-2 text-[13px] leading-5 text-gray-400">
            If you think this is an error, please contact our support team and we'll
            help you get back in.
          </p>

          <button
            type="button"
            onClick={onContactSupport}
            className="mt-6 inline-flex h-12 w-full items-center justify-center gap-2 rounded-xl border border-rose-400/30 bg-rose-500 px-5 text-sm font-black text-white shadow-[0_16px_32px_rgba(239,68,68,0.24)] transition-all hover:bg-rose-600"
          >
            <Icon icon="bx:message-dots" className="h-5 w-5" />
            Contact support
          </button>
        </div>
      </div>
    </div>
  );
};

export default BlockedUserModal;